import React from 'react';
import { Typography, Link } from '@mui/material';
import TmDeny from '../../../icons/TmDeny';

interface DenyButtonProps {
    onClick: () => void;
    children: string;
    disabled?: boolean;
  }

  
const DenyButton: React.FC<DenyButtonProps> = ({ onClick, children, disabled = false }) => {
  const style = disabled ? {
    color: "white",
    backgroundColor: "#cccccc",
    borderColor: "#cccccc",
    pointerEvents: "none", // Prevents click events
    textDecoration: "none",
  } : {
    color: "white",
    backgroundColor: "#ec4a71"
  };

  return (
    <Link href="#"
        py={1} px={2} sx={style} 
        display="inline-flex"
        fontWeight="bold"
        underline="none"
        border={1}
        borderRadius={25}
        borderColor="#ec4a71"
    onClick={!disabled ? onClick : undefined}><TmDeny stroke="white" /><Typography fontWeight="bold">&nbsp;&nbsp;{children}</Typography></Link>
  );
}

export default DenyButton;
